import { CommandGroup, CommandItem } from "@components/ui/command";
import { Link } from "react-router-dom";
import { formatToCurrency, formatDateToLocale } from "@utils/formatting";
import type { StudentSearchResult } from "@shared-kernel/application/ports/admin/admin-repository";
import { studentStatusFormatter } from "@user-management-context/primary/shared/status-formatter";

interface Props {
  students: StudentSearchResult[];
  onSelect: (entityId: string) => void;
  getUrl: (entityId: string) => string;
  onClose: () => void;
}

export const StudentResultGroup = ({ students, onSelect, getUrl, onClose }: Props) => {
  if (students.length === 0) return null;

  return (
    <CommandGroup heading="Élèves">
      {students.map(student => (
        <CommandItem key={student.entityId} value={student.entityId} onSelect={() => onSelect(student.entityId)} className="p-0">
          <Link
            to={getUrl(student.entityId)}
            className="flex w-full items-center gap-3 px-2 py-1.5"
            onClick={e => {
              if (e.metaKey || e.ctrlKey) {
                e.stopPropagation();
              } else {
                onClose();
              }
            }}
          >
            {studentStatusFormatter(student.metadata)}
            <span className="flex-1 truncate">{student.label}</span>
            {student.metadata.afdasISWaitingPeriodEndDate && (
              <span className="text-xs text-muted-foreground">
                AFDAS {formatDateToLocale(student.metadata.afdasISWaitingPeriodEndDate)}
              </span>
            )}
            <span className="ml-auto text-xs text-muted-foreground">{formatToCurrency(student.metadata.balance)}</span>
          </Link>
        </CommandItem>
      ))}
    </CommandGroup>
  );
};
